module.exports = __webpack_public_path__ + "img/bg_avatar_female_34.6ab09607.png";